import { FC, useRef } from "react";
import * as _ from "lodash";
import * as Sentry from "@sentry/react";

import { Col, Row, Skeleton } from "@ctra/components";
import { classname } from "@ctra/utils";

import { Chart, ChartFilterContext, ChartAPIContext } from "@chart";
import { useInsight, InsightValidation, KPIInsight } from "@insights";

import baseStyles from "../InsightBody/InsightBody.module.less";
import styles from "./KPIInsightBody.module.less";

/**
 * Insight body for KPI insights
 * @constructor
 */
export const KPIInsightBody: FC = () => {
  const {
    insight: { farm },
    getMetadata,
    getTargetGroupName,
    meta: { isLoading }
  } = useInsight<KPIInsight>();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ref = useRef<any>();

  const {
    dataDescriptor: { id },
    chart: { timePeriod }
  } = getMetadata();

  /**
   * Get the group, which is either going to be herd group or pen
   */
  const [type, value] = _.split(getTargetGroupName(), " ");

  /**
   * if there is a pen name group, use that in filters
   */
  const penName = _.isEqual(type, "Pen") ? [value] : [];

  return (
    <Skeleton active loading={isLoading}>
      <Row className={classname(baseStyles.Row, baseStyles.Padded)}>
        <Col flex={1}>
          <InsightValidation />
        </Col>
      </Row>
      <Sentry.ErrorBoundary fallback={<>{null}</>}>
        <Row className={classname(styles.ChartContainer, baseStyles.Row, baseStyles.PaddedChart)}>
          <Col flex={1}>
            <ChartFilterContext.Provider
              timePeriod={timePeriod}
              series={_.size(penName) ? { [id]: _.values(penName) } : void 0}
              filters={_.size(penName) ? { [id]: { penName } } : void 0}
            >
              <ChartAPIContext.Provider metricVariantID={id} farmID={farm}>
                <Chart
                  ref={ref}
                  viewOptions={{ showToolbar: true, zoomEnabled: false }}
                  config={{
                    onReady: (plot) => {
                      ref.current = plot;
                    }
                  }}
                />
              </ChartAPIContext.Provider>
            </ChartFilterContext.Provider>
          </Col>
        </Row>
      </Sentry.ErrorBoundary>
    </Skeleton>
  );
};
